import React from 'react';
import { Link } from 'react-router-dom';
export function TopBar() {
  return <div className="w-full bg-forest-700 text-ivory" data-id="element-577" data-mp="3bzsw5094l3yu">
      <div className="max-w-container mx-auto flex h-9 items-center justify-between px-5 text-[12px] md:px-8 lg:px-10" data-id="element-578" data-mp="3c1dsmvf02wzc">
        <p className="truncate font-medium tracking-[0.02em] text-ivory/85" data-id="element-579" data-mp="2y24h491qor1p">
          International Islamic Learning Hub
        </p>
        <div className="ml-4 flex shrink-0 items-center gap-2" data-id="element-580" data-mp="3pqpely9c84s6">
          <Link to="/en" className="font-semibold text-ivory transition hover:text-sand-200" aria-label="English version" data-id="element-581" data-mp="3ptag2m5q4ipe">
            English
          </Link>
          <span className="text-ivory/40" aria-hidden="true" data-id="element-582" data-mp="3gx2vb7mbgtzv">|</span>
          <Link to="/ar" className="font-medium text-ivory/75 transition hover:text-sand-200" aria-label="Arabic version" data-id="element-583" data-mp="3kyxy6gjwbffr">
            العربية
          </Link>
        </div>
      </div>
    </div>;
}